<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1 style="display: none">
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row
      v-else
      id="todoId"
    >
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row id="analiseFaturamentoFltrosId">
          <v-col
            cols="12"
            sm="12"
            md="5"
            lg="5"
          >
            <h3
              v-if="enableTituloWeb"
              id="textoTitulo"
              class="text-center"
              :style="styleObject"
            >
              RELATÓRIO DE ACOMPANHAMENTO DE CONSULTOR DE VENDAS
            </h3>
            <v-row
              v-if="enableBtnPrint"
              id="btnPrint"
            >
              <v-btn
                v-if="loadingBtnPrint"
                class="col-3 lg-3"
                small
                :color="corPrimaria"
                dark
                @click="imprimir()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Imprimir
              </v-btn>
            </v-row>
          </v-col>
          <v-col
            v-if="enableTituloWeb"
            cols="12"
            sm="12"
            md="7"
            lg="7"
          >
            <dashboard-filtros
              id="idFiltro"
              :vendedores="enableVendedores"
              :redes="enableRedes"
              :meses="enableMeses"
              :anos="enableAnos"
              :btn1="enableBtn"
            />
          </v-col>
          <v-col
            v-if="enableTituloPrint"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div
              v-if="loadingPrint"
              :style="styleObject"
              class="text-center"
            >
              <v-icon
                light
                class="custom-loader"
                :style="styleObject"
              >
                mdi-cached
              </v-icon>
              Gerando pdf...
            </div>
            <v-row
              id="filtrosPrint"
            >
              <v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <h3
                    class="text-center"
                    :style="styleObject"
                  >
                    RELATÓRIO DE ACOMPANHAMENTO DE PROMOTOR DE VENDAS - {{ mesPrint }} / {{ anoPrint }}
                  </h3>
                </v-col>
                <h3
                  class="text-center"
                  :style="styleObject"
                >
                  VENDEDOR: {{ vendedorPrint }}
                </h3>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider
          id="idDivisao"
          class="mb-5"
        />
        <v-row id="idBloco1">
          <v-col
            cols="12"
            sm="12"
            md="10"
            lg="10"
          >
            <dashboard-faturamento-semanal />
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="2"
            lg="2"
          >
            <dashboard-meta-faturamento />
          </v-col>
        </v-row>
        <v-row
          v-if="enableTextoWeb"
          id="idBloco2"
        >
          <v-col
            id="bloco2"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <dashboard-devolucao-total />
          </v-col>
        </v-row>
        <v-row v-if="enableTextoPrint">
          <v-col
            id="devolucaoDetalhePrintId"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-row>
              <v-col
                cols="10"
                offset="1"
              >
                <v-row>
                  <v-col cols="6">
                    <div
                      id="textoPrint"
                      class="borderPrint"
                    >
                      <h3
                        id="titulo"
                        class="text-center"
                      >
                        DEVOLUÇÕES DO PERÍODO
                      </h3>
                    </div>
                  </v-col>
                  <v-col
                    id="valorDevTotalId"
                    cols="6"
                  >
                    <div
                      id="textoPrint"
                      class="borderPrint"
                    >
                      <h3
                        id="titulo"
                        class="text-center"
                        :style="styleFaturamento"
                      >
                        {{ valorDevolucaoPrint }}
                      </h3>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="10"
                offset="1"
              >
                <canvas
                  id="graficoDevolucaoDetalheTotalPrint"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-row id="tiposDevolucaoIdPrint">
              <v-col
                cols="10"
                offset="1"
              >
                <v-row>
                  <v-col
                    cols="4"
                  >
                    <div
                      id="textoQuebraPrint"
                      class="borderPrint"
                    >
                      <h3
                        id="titulo"
                        class="text-center"
                      >
                        TOTAL QUEBRA
                      </h3>
                    </div>
                    <canvas
                      id="graficoDevolucaoQuebraPrint"
                    />
                    <div
                      id="textoQuebraPrint"
                      class="text-center"
                    >
                      VALOR TOTAL <span :style="styleFaturamento">{{ valorQuebra }}</span>
                    </div>
                  </v-col>
                  <v-col
                    cols="4"
                  >
                    <div
                      id="textoTrocaPrint"
                      class="borderPrint"
                    >
                      <h3
                        id="titulo"
                        class="text-center"
                      >
                        TOTAL TROCA
                      </h3>
                    </div>
                    <canvas
                      id="graficoTotalTrocaPrint"
                    />
                    <div
                      id="textoTrocaPrint"
                      class="text-center"
                    >
                      VALOR TOTAL <span :style="styleFaturamento">{{ valorTroca }}</span>
                    </div>
                  </v-col>
                  <v-col
                    cols="4"
                  >
                    <div
                      id="textoDevolucaoPrint"
                      class="borderPrint"
                    >
                      <h3
                        id="titulo"
                        class="text-center"
                      >
                        TOTAL DEVOLUÇÕES
                      </h3>
                    </div>
                    <canvas
                      id="graficoTotalDevolucaoPrint"
                    />
                    <div
                      id="textoDevolucaoPrint"
                      class="text-center"
                    >
                      VALOR TOTAL <span :style="styleFaturamento">{{ valorDetalheDevolucao }}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="enableTextoPrint">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-row id="blocoParticipantesNovosIdPrint">
              <v-col
                cols="12"
                sm="6"
                md="6"
                lg="6"
              >
                <v-row
                  id="idClientesParticantes"
                >
                  <v-col
                    id="clientesParticantesPrint"
                    cols="12"
                    class="tituloWeb"
                  >
                    <h2 class="text-center">
                      Como estão meus participantes?
                    </h2>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    id="coberturaParticipantesPrint"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                    class="text-center"
                  >
                    <canvas
                      id="graficoPorcentagemClientesPrint"
                      width="150"
                      height="70"
                    />
                    <div
                      v-if="porcentagemFaturados"
                      id="porcentagemClienteFaturadoPrint"
                      :style="styleCliente"
                    >
                      {{ porcentagemFaturados }}
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    id="positivadosPrint"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <span
                      id="clientePositivadosPrint"
                      :style="styleCliente"
                    >
                      <router-link
                        to="/clientes/detalhe-clientes-faturado"
                        :style="styleObject"
                      >
                        <v-icon>
                          mdi-arrow-top-right-bold-box-outline
                        </v-icon>
                      </router-link>
                      {{ clientesFaturado }}
                    </span>
                    Positivados
                  </v-col>
                  <v-col
                    id="ativosPrint"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <span
                      id="clientePositivadosPrint"
                      :style="styleCliente"
                    >
                      <router-link
                        to="/clientes/detalhe-total-clientes"
                        :style="styleObject"
                      >
                        <v-icon>
                          mdi-arrow-top-right-bold-box-outline
                        </v-icon>
                      </router-link>
                      {{ semFaturamento }}
                    </span>
                    Sem Faturamento
                  </v-col>
                  <v-col
                    v-if="clientesAtivos"
                    id="clientesAtivosPrint"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <span
                      id="clientePositivadosPrint"
                      :style="styleCliente"
                    >
                      {{ clientesAtivos }}
                    </span>
                    Clientes Ativos
                  </v-col>
                  <v-col
                    v-if="fornecedoresAtivos"
                    id="fornecedoresAtivosPrint"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <span
                      id="clientePositivadosPrint"
                      :style="styleCliente"
                    >
                      {{ fornecedoresAtivos }}
                    </span>
                    Fornecedores Ativos
                  </v-col>
                  <v-col
                    v-if="produtoresAtivos"
                    id="produtoresAtivosPrint"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <span
                      id="clientePositivadosPrint"
                      :style="styleCliente"
                    >
                      {{ produtoresAtivos }}
                    </span>
                    Produtores Ativos
                  </v-col>
                  <v-col
                    v-if="funcionariosAtivos"
                    id="funcionariosAtivosPrint"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <span
                      id="clientePositivadosPrint"
                      :style="styleCliente"
                    >
                      {{ funcionariosAtivos }}
                    </span>
                    Funcionários Ativos
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                lg="6"
              >
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                    class="tituloWeb"
                  >
                    <h2
                      id="participacaoNovosId"
                      class="text-center"
                    >
                      E a participação de novos clientes?
                    </h2>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <div
                      id="textoClientesNovosPrint"
                      class="text-center"
                      :style="styleCurrency"
                    >
                      {{ clientesNovos }} Clientes Novos
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <div
                      id="iconCombinadoPrint"
                      class="text-center"
                    >
                      <v-icon
                        id="handClientePrint"
                        :style="styleCurrency"
                      >
                        mdi-hand-extended-outline
                      </v-icon>
                      <v-icon
                        id="currencyClientePrint"
                        class="text-center"
                        :style="styleCurrency"
                      >
                        mdi-currency-usd
                      </v-icon>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <v-row
                      id="textoParticipacaoPrint"
                    >
                      Part. do Faturamento
                    </v-row>
                    <v-row
                      id="percentualParticipacaoPrint"
                    >
                      {{ participacaoClientesNovos }}
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <canvas
                      id="graficoComparativoClientesNovosPrint"
                      width="180"
                      height="130"
                    />
                    <div
                      v-if="exibirLegenda"
                      id="legendaDistribuicaoClientePrint"
                      class="text-center"
                    >
                      <v-row
                        align="center"
                        class="ma-0"
                        no-gutters
                      >
                        <v-col
                          md="6"
                          offset-md="3"
                        >
                          <v-row>
                            <div
                              v-for="status in statusDistruibuicao"
                              :key="status.statusExibicao"
                            >
                              <v-avatar
                                class="mr-1"
                                :color="status.corExibicao"
                                size="12"
                              />
                              <span class="mr-3 font-weight-light">{{ status.statusExibicao }}</span>
                            </div>
                          </v-row>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-row id="blocoMapsPrintId">
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                class="tituloWeb"
              >
                <h2
                  id="textoMapsId"
                  class="text-center"
                >
                  Qual a distribuição geográfica dos meus clientes?
                </h2>
              </v-col>
              <v-col
                cols="12"
                sm="10"
                md="10"
                lg="10"
              >
                <v-data-table
                  id="tabelaMapsPrint"
                  class="elevation-1"
                  :headers="headersMapsClientes"
                  :items="dadosMapsClientes"
                  :items-per-page="dadosMapsClientes.length"
                  hide-default-footer
                  disable-sort
                  style="color: black"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          v-if="enableTextoWeb"
          id="idBloco3"
        >
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="3"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div
                v-if="enableTextoWeb"
                id="idClientesParticantes"
                class="card-header-dashbord"
              >
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Como estão meus participantes?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip top>
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          class="text-right"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('159')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="codigo === '159'"
                        v-html="textoParticipantes"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <div class="textoClientesParticantes">
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-row>
                        <v-col
                          id="clientesParticantesId"
                          cols="12"
                          class="text-center"
                        >
                          Cobertura de participantes
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          class="text-center"
                        >
                          <dashboard-cobertura-participantes /><br>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <div
                    v-if="loading"
                    :style="styleObject"
                    class="text-center"
                  >
                    <v-icon
                      light
                      class="custom-loader"
                      :style="styleObject"
                    >
                      mdi-cached
                    </v-icon>
                    Carregando dados...
                  </div>
                  <div
                    v-else-if="error"
                    class="alert alert-danger"
                  >
                    {{ error }}
                  </div>
                  <div
                    v-else
                  >
                    <v-row>
                      <v-col
                        id="clientesPositivadosPrint"
                        cols="6"
                        class="text-center"
                      >
                        <span
                          id="clientePositivados"
                          :style="styleCliente"
                        >
                          <router-link
                            to="/clientes/detalhe-clientes-faturado"
                            :style="styleObject"
                          >
                            <v-icon>
                              mdi-arrow-top-right-bold-box-outline
                            </v-icon><br>
                          </router-link>
                          {{ clientesFaturado }}
                        </span><br>
                        Positivados
                      </v-col>
                      <v-col
                        id="clientesTotalAtivosPrint"
                        cols="6"
                        class="text-center"
                        style="margin: 0 0 0 -2rem;"
                      >
                        <span
                          id="clientePositivados"
                          :style="styleCliente"
                        >
                          <router-link
                            to="/clientes/detalhe-total-clientes"
                            :style="styleObject"
                          >
                            <v-icon>
                              mdi-arrow-top-right-bold-box-outline
                            </v-icon><br>
                          </router-link>
                          {{ semFaturamento }}
                        </span><br>
                        Clientes Sem faturamento
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        v-if="clientesAtivos"
                        id="clientesAtivos"
                        cols="6"
                        class="text-center"
                      >
                        <span
                          id="clientePositivados"
                          :style="styleCliente"
                        >
                          {{ clientesAtivos }}
                        </span><br>
                        Clientes Ativos
                      </v-col>
                      <v-col
                        v-if="fornecedoresAtivos"
                        id="fornecedoresAtivosPrint"
                        cols="6"
                        class="text-center"
                      >
                        <span
                          id="clientePositivados"
                          :style="styleCliente"
                        >
                          {{ fornecedoresAtivos }}
                        </span><br>
                        Fornecedores Ativos
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        v-if="produtoresAtivos"
                        id="produtoresAtivosPrint"
                        cols="6"
                        class="text-center"
                      >
                        <span
                          id="clientePositivados"
                          :style="styleCliente"
                        >
                          {{ produtoresAtivos }}
                        </span><br>
                        Produtores Ativos
                      </v-col>
                      <v-col
                        v-if="funcionariosAtivos"
                        id="funcionariosAtivosPrint"
                        cols="6"
                        class="text-center"
                      >
                        <span
                          id="clientePositivados"
                          :style="styleCliente"
                        >
                          {{ funcionariosAtivos }}
                        </span><br>
                        Funcionários Ativos
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card-actions><br>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Qual a distribuição geográfica dos meus clientes?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip top>
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationClientesParcipantes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('160')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="codigo === '160'"
                        v-html="textoDistribuicaoParticipantes"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-maps-cliente id="mapsPrint" />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="3"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    E a participação de novos clientes?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip top>
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationFatxMetaComercial4"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('161')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="codigo === '161'"
                        v-html="textoParticipantesNovos"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <div
                      v-if="loading"
                      :style="styleObject"
                      class="text-center"
                    >
                      <v-icon
                        light
                        class="custom-loader"
                        :style="styleObject"
                      >
                        mdi-cached
                      </v-icon>
                      Carregando dados...
                    </div>
                    <div
                      v-else-if="error"
                      class="alert alert-danger"
                    >
                      {{ error }}
                    </div>
                    <div v-else>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <v-row>
                            <v-col
                              cols="12"
                              sm="10"
                              md="10"
                              lg="10"
                            >
                              <div
                                id="textoClientesNovos"
                                class="text-center"
                                :style="styleCurrency"
                              >
                                {{ clientesNovos }} Clientes Novos
                              </div>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="2"
                              md="2"
                              lg="2"
                            >
                              <router-link
                                to="/clientes/detalhe-novos-clientes-faturado"
                                :style="styleObject"
                              >
                                <v-icon
                                  id="linkNovosClientes"
                                >
                                  mdi-arrow-top-right-bold-box-outline
                                </v-icon><br>
                              </router-link>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row><br><br><br><br><br>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="6"
                          lg="6"
                        >
                          <div
                            id="iconCombinado"
                            class="text-center"
                          >
                            <v-icon
                              id="handCliente"
                              :style="styleCurrency"
                            >
                              mdi-hand-extended-outline
                            </v-icon>
                            <v-icon
                              id="currencyCliente"
                              class="text-center"
                              :style="styleCurrency"
                            >
                              mdi-currency-usd
                            </v-icon>
                          </div>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="6"
                          lg="6"
                        >
                          <v-row
                            id="textoParticipacao"
                          >
                            Part. do Faturamento
                          </v-row>
                          <v-row
                            id="percentualParticipacao"
                          >
                            {{ participacaoClientesNovos }}
                          </v-row>
                        </v-col>
                      </v-row><br><br><br>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <div v-if="!text">
                            <div
                              v-if="loadingGrafico"
                              id="carregaDados"
                              class="text-center"
                              :style="styleObject"
                            >
                              <v-icon
                                light
                                class="custom-loader"
                                :style="styleObject"
                              >
                                mdi-cached
                              </v-icon>
                              Carregando Dados...
                            </div>
                            <div
                              v-else-if="errorGrafico"
                              class="alert alert-danger"
                            >
                              {{ errorGrafico }}
                            </div>
                            <canvas
                              id="myChart34"
                              width="180"
                              height="130"
                            />
                            <br><br>
                            <div
                              v-if="exibirLegenda"
                              id="legendaDistribuicaoCliente"
                              class="text-center"
                            >
                              <v-row
                                align="center"
                                class="ma-0"
                                no-gutters
                              >
                                <v-col
                                  md="6"
                                  offset-md="3"
                                >
                                  <v-row>
                                    <div
                                      v-for="status in statusDistruibuicao"
                                      :key="status.statusExibicao"
                                    >
                                      <v-avatar
                                        class="mr-1"
                                        :color="status.corExibicao"
                                        size="12"
                                      />
                                      <span class="mr-3 font-weight-light">{{ status.statusExibicao }}</span>
                                    </div>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                          <div
                            v-else
                          >
                            {{ text }}
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row><br>
        <v-divider class="mb-5" />
        <v-row id="idBloco4">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-row v-if="enableTextoPrint">
              <v-col
                cols="12"
                class="tituloWeb"
              >
                <h2>Como está a minha distribuição de clientes nos últimos 12 meses?</h2>
              </v-col>
            </v-row>
            <v-card
              v-if="enableTextoWeb"
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Como está a minha distribuição de clientes nos últimos 12 meses?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip top>
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationFatxMetaComercial4"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('162')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="codigo === '162'"
                        v-html="textoDistribuicaoMeses"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-distribuicao-novos-clientes />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row><br>
        <v-divider class="mb-5" />
        <show-dados-clientes-sem-faturamento id="idBloco5" /><br>
        <v-divider class="mb-5" />
        <v-row id="segmentacaoMelhoresClientesPrint">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-card
              v-if="enableTextoWeb"
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Qual a segmentação predominante?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip top>
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationSegmentacaoClientes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('165')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="codigo === '165'"
                        v-html="textoParticpantesSegmento"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-segmentacao-clientes />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-card
              v-if="enableTextoWeb"
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Quais são os 20 melhores clientes que performaram no ano?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip top>
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationSegmentacaoClientes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('166')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="codigo === '166'"
                        v-html="textoParticpantesMelhores"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <show-melhores-clientes />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row><br>
        <v-row id="idBloco7">
          <v-col
            id="maiorDevolucaoColunaPrint"
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <show-dados-devolucoes-clientes />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <show-dados-perfomance-cliente />
              </v-col>
            </v-row>
          </v-col>
        </v-row><br>
        <v-divider class="mb-5" />
        <v-row id="idBloco8">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <show-clientes-maiores-crescimento />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <show-clientes-piores-crescimento />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import Clientes from '../../../../services/clientes'
  import eventEmit from '../../components/core/EventoEmit'
  import Chart from 'chart.js'
  import html2canvas from 'html2canvas'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardPromotorVendas',
    emits: ['updateDadosForm', 'exibirLegendaMapsPrint', 'enablePrint', 'disablePrint', 'enableMap', 'disableMap', 'enableGraficoCobertura', 'enableCoberturaParticipantes', 'enableDetalheDevolucao', 'enableQuebra', 'enableTroca', 'enableDevTotal', 'enableFiltrosPrint', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltros: () => import('../../components/core/FiltrosSaborDaSerra'),
      DashboardFaturamentoSemanal: () => import('../../components/comercial/comercialPersonalizado/FaturamentoSemanal'),
      DashboardMetaFaturamento: () => import('../../components/comercial/comercialPersonalizado/MetaFaturamento'),
      DashboardDevolucaoTotal: () => import('../../components/comercial/comercialPersonalizado/DetalheDevolucaoTotal'),
      DashboardCoberturaParticipantes: () => import('../../graficos/Clientes/CoberturaParticipantes'),
      DashboardMapsCliente: () => import('../../maps/Cliente/DashboardMapsCliente'),
      DashboardDistribuicaoNovosClientes: () => import('../../graficos/Clientes/DistribuicaoNovosClientes'),
      ShowDadosClientesSemFaturamento: () => import('../../components/comercial/clientes/ClientesSemFaturamento'),
      DashboardSegmentacaoClientes: () => import('../../graficos/Clientes/SegmentacaoClientes'),
      ShowMelhoresClientes: () => import('../../components/comercial/clientes/ClientesExibicaoMelhores'),
      ShowDadosDevolucoesClientes: () => import('../../components/comercial/clientes/ClientesDadosDevolucoes'),
      ShowDadosPerfomanceCliente: () => import('../../components/comercial/clientes/ClientesDadosPerfomance'),
      ShowClientesMaioresCrescimento: () => import('../../components/comercial/clientes/ClientesDadosMaioresCrescimento'),
      ShowClientesPioresCrescimento: () => import('../../components/comercial/clientes/ClientesDadosPioresCrescimento'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleCliente: {
        color: '#ed934f',
      },
      styleCurrency: {
        color: '#4CAF50',
      },
      styleTexto: {
        color: '#00796B',
      },
      styleFaturamento: {
        color: '#C62828',
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      link: window.location.href,
      ano: [],
      mes: [],
      vendedores: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      empresaSelect: [],
      receitaSelect: [],
      dataInicial: '',
      dataFinal: '',
      paginaEnable: true,
      enableVendedores: true,
      enableRedes: false,
      enableMeses: true,
      enableAnos: true,
      enableBtn: true,
      enableBtnPrint: false,
      mesPrint: false,
      anoPrint: false,
      vendedorPrint: false,
      codigo: 0,
      codigoIds: ['159', '160', '161', '162', '163', '164', '165', '166', '167', '168', '169', '170', '263', '264', '265', '266', '267', '268', '269', '270', '271', '272', '273', '274', '275', '276', '277', '278', '279', '280', '281', '282', '283', '284', '318', '319', '320', '321', '322', '323', '324', '325', '326', '327'],
      orientacao: [],
      textoParticipantes: '',
      textoDistribuicaoParticipantes: '',
      textoParticipantesNovos: '',
      textoDistribuicaoMeses: '',
      textoPartipantesSemFat: '',
      textoPartipantesInativos: '',
      textoParticpantesSegmento: '',
      textoParticpantesMelhores: '',
      textoParticpantesDevolucao: '',
      textoParticpantesPerfomance: '',
      textoParticpantesCrescendo: '',
      textoParticpantesCaindo: '',
      clientesFaturado: 0,
      clientesTotalAtivos: 0,
      semFaturamento: 0,
      clientesAtivos: 0,
      fornecedoresAtivos: 0,
      produtoresAtivos: 0,
      funcionariosAtivos: 0,
      clientesNovos: 0,
      participacaoClientesNovos: 0,
      loading: false,
      loading1: false,
      error: null,
      error1: null,
      loadingGrafico: false,
      text: null,
      montaGrafico: true,
      errorGrafico: null,
      exibirLegenda: false,
      myChart: {},
      myChartPrint: {},
      myChartSegmentacaoClinte: {},
      myChartCoberturaParticipantes: {},
      mychartDevolucaoTotal: {},
      mychartDevolucaoTotalQuebra: {},
      mychartDevolucaoTotalTroca: {},
      mychartDevolucaoTotalPrint: {},
      dadosMelhoresClientes: [],
      headersMelhoresCliente: [],
      statusDistruibuicao: [
        { statusExibicao: 'Clientes novos', corExibicao: '#4CAF50' },
        { statusExibicao: 'Clientes', corExibicao: '#E8F5E9' },
      ],
      loadingPrint: false,
      loadingBtnPrint: true,
      enableTituloWeb: true,
      enableTituloPrint: false,
      clientesMaiorCrescimento: [],
      headersClientesMelhoresPiores: [],
      headersPioresClientes: [],
      clientesPioresCrescimento: [],
      headersSemFaturamento: [],
      clientesSemFaturamento: [],
      clientesInativo: [],
      headersPerformanceClientes: [],
      performanceClientes: [],
      headersDevolucaoClientes: [],
      devolucaoClientes: [],
      headersMelhoresClientes: [],
      melhoresClientes: [],
      enableTextoPrint: false,
      enableTextoWeb: true,
      dadosMapsClientes: [],
      valorDevolucaoPrint: 0,
      headersMapsClientes: [
        { text: 'Nome', value: 'nome', align: 'left', class: 'black--text title', sytle: 'margin-left: -1rem' },
        { text: 'Quantidade', value: 'numero', align: 'right', class: 'black--text title' },
        { text: 'Porcentagem', value: 'porcentagem', align: 'right', class: 'black--text title' },
      ],
      datasComparativo: [],
      faturamentoNovosClientes: [],
      faturamentoClientes: [],
      porcentagem: 0,
      restante: 0,
      porcentagemFaturados: 0,
      labelsDevolucaTotal: [],
      quantidadeDevolucaoTotal: [],
      labelsQuebraTotal: [],
      quantidadeQuebraTotal: [],
      labelsTrocaTotal: [],
      quantidadetrocaTotal: [],
      labelsDetalheTotal: [],
      quantidadeDetalheTotal: [],
      valorQuebra: 0,
      valorTroca: 0,
      valorDetalheDevolucao: 0,
      locations: [],
      zoom: [],
      center: [],
      dynamicPaddingCliente1: '',
      dynamicPaddingCliente2: '',
      dynamicPaddingCliente3: '',
      dynamicPaddingCliente4: '',
      dynamicPaddingCliente5: '',
    }),

    created () {
      eventEmit.$on('update-dados-filtros', this.handleUpdateDados)

      eventEmit.$on('update-btn-print', this.enablePrint)

      eventEmit.$on('envio-dados-grafico-segmento', this.handleGrafico)

      eventEmit.$on('envio-dados-table', this.handleDadosTable)

      eventEmit.$on('envio-piores-crescimento', this.handleDadosTablePioresCrescimento)

      eventEmit.$on('enable-dados-sem-faturamento', this.handleDadosTableSemFaturamento)

      eventEmit.$on('envio-performance', this.handlePerformance)

      eventEmit.$on('envio-devolucao', this.handleDevolucao)

      eventEmit.$on('envio-melhores-clientes', this.handleMelhoresClientes)

      eventEmit.$on('dados-maps-cliente', this.handleMapsClientes)

      eventEmit.$on('envio-cobertura-participantes', this.handleCoberturaParticipantes)

      eventEmit.$on('dados-total-devolucao', this.handleTotaldevolucao)

      eventEmit.$on('enable-devolucao-quebra', this.handleQuebraDevolucao)

      eventEmit.$on('enable-devolucao-troca', this.handleTrocaDevolucao)

      eventEmit.$on('enable-devolucao-detalhe', this.handleDetalheDevolucao)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-filtros', this.handleUpdateDados)

      eventEmit.$off('update-btn-print', this.enablePrint)

      eventEmit.$off('envio-dados-grafico-segmento', this.handleGrafico)

      eventEmit.$off('envio-dados-table', this.handleDadosTable)

      eventEmit.$off('envio-piores-crescimento', this.handleDadosTablePioresCrescimento)

      eventEmit.$off('enable-dados-sem-faturamento', this.handleDadosTableSemFaturamento)

      eventEmit.$off('envio-performance', this.handlePerformance)

      eventEmit.$off('envio-devolucao', this.handleDevolucao)

      eventEmit.$off('envio-melhores-clientes', this.handleMelhoresClientes)

      eventEmit.$off('dados-maps-cliente', this.handleMapsClientes)

      eventEmit.$off('envio-cobertura-participantes', this.handleCoberturaParticipantes)

      eventEmit.$off('dados-total-devolucao', this.handleTotaldevolucao)

      eventEmit.$off('enable-devolucao-quebra', this.handleQuebraDevolucao)

      eventEmit.$off('enable-devolucao-troca', this.handleTrocaDevolucao)

      eventEmit.$off('enable-devolucao-detalhe', this.handleDetalheDevolucao)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Consultor Vendas')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        Permissao.showPermissaoPagina(localStorage.username, window.location.href, localStorage.tokencontrato, this.codigoIds).then(resposta => {
          if (resposta.data.status) {
            this.paginaEnable = true

            this.orientacao = resposta.data.orientacao

            if (this.$store.state.versao < resposta.data.versao) {
              this.$router.go()
            }
          } else {
            this.$router.push('/dashboard')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.message === 'Permissão para a pagina não encontrada, metodo 8') {
            this.$router.push('/dashboard')
          }
        })

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingCliente1 = 'padding-right: 12rem !important'

          this.dynamicPaddingCliente2 = 'padding-right: 36rem !important'

          this.dynamicPaddingCliente3 = 'padding-right: 9rem !important'

          this.dynamicPaddingCliente4 = 'padding-right: 95rem !important'

          this.dynamicPaddingCliente5 = 'padding-right: 30rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingCliente1 = 'padding-right: 2rem !important'

          this.dynamicPaddingCliente2 = 'padding-right: 18rem !important'

          this.dynamicPaddingCliente3 = 'padding-right: 0.5rem !important'

          this.dynamicPaddingCliente4 = 'padding-right: 58rem !important'

          this.dynamicPaddingCliente5 = 'padding-right: 11.4rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingCliente1 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente2 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente3 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente4 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente5 = 'padding-right: 5rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingCliente1 = 'padding-right: 25rem !important'

          this.dynamicPaddingCliente2 = 'padding-right: 25rem !important'

          this.dynamicPaddingCliente3 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente4 = 'padding-right: 25rem !important'

          this.dynamicPaddingCliente5 = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingCliente1 = 'padding-right: 2rem !important'

          this.dynamicPaddingCliente2 = 'padding-right: 17rem !important'

          this.dynamicPaddingCliente3 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente4 = 'padding-right: 55rem !important'

          this.dynamicPaddingCliente5 = 'padding-right: 14rem !important'
        }
      },

      handleUpdateDados (vendedor, redes, mes, ano) {
        this.vendedores = vendedor
        this.mes = mes
        this.ano = ano

        this.vendedorPrint = vendedor[0].vendedor.toUpperCase()
        this.mesPrint = mes[0].texto.toUpperCase()
        this.anoPrint = ano[0]

        const mesValor = mes[0].valor - 1

        this.dataInicial = (new Date(ano[0], mesValor, 1)).toISOString().substr(0, 10)
        this.dataFinal = (new Date(ano[0], mesValor + 1, 0)).toISOString().substr(0, 10)

        this.updateDados()
      },

      enablePrint (enable) {
        this.enableBtnPrint = enable
      },

      updateDados () {
        if (this.vendedores.length > 0) {
          this.enableBtnPrint = false

          this.clientesFaturado = 0
          this.clientesTotalAtivos = 0
          this.semFaturamento = 0
          this.clientesAtivos = 0
          this.fornecedoresAtivos = 0
          this.produtoresAtivos = 0
          this.funcionariosAtivos = 0
          this.clientesNovos = 0
          this.participacaoClientesNovos = 0

          this.showDadosClientesFaturado()
          this.showDadosNovosClientes()
          this.MontarGrafico()

          eventEmit.$emit('update-dados-form', this.mes, this.ano, this.vendedores)

          eventEmit.$emit('set-localizcao-cliente', this.dataInicial, this.dataFinal, this.empresaSelect, this.vendedores, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receitaSelect, [], [], [])

          eventEmit.$emit('set_faturamento_novos_clientes', this.dataInicial, this.dataFinal, this.empresaSelect, this.vendedores, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receitaSelect, [], [], [])
        } else {
          alert('Favor selecionar um vendedor para poder realizar a consulta.')
        }
      },

      handleDadosTable (headers, table) {
        this.clientesMaiorCrescimento = table

        this.headersClientesMelhoresPiores = headers
      },

      handleDadosTablePioresCrescimento (headers, table) {
        this.clientesPioresCrescimento = table

        this.headersPioresClientes = headers
      },

      handleDadosTableSemFaturamento (headersClientes, clientesSemFaturamento, clientesInativo) {
        this.headersSemFaturamento = headersClientes
        this.clientesSemFaturamento = clientesSemFaturamento
        this.clientesInativo = clientesInativo
      },

      handlePerformance (headersPerformanceClientes, performanceClientes) {
        this.headersPerformanceClientes = headersPerformanceClientes
        this.performanceClientes = performanceClientes
      },

      handleDevolucao (headersDevolucaoClientes, devolucaoClientes) {
        this.headersDevolucaoClientes = headersDevolucaoClientes
        this.devolucaoClientes = devolucaoClientes
      },

      handleMelhoresClientes (headersMelhoresClientes, melhoresClientes) {
        this.headersMelhoresClientes = headersMelhoresClientes
        this.melhoresClientes = melhoresClientes
      },

      handleMapsClientes (dados, locations, zoom, center) {
        this.dadosMapsClientes = dados
        this.locations = locations
        this.zoom = zoom
        this.center = center
      },

      handleCoberturaParticipantes (porcentagem, restante) {
        this.porcentagem = porcentagem
        this.restante = restante
        this.porcentagemFaturados = porcentagem.toFixed(2).toString().replace('.', ',') + '%'
      },

      handleTotaldevolucao (labels, quantidade, valorDevolucaoPrint) {
        this.valorDevolucaoPrint = valorDevolucaoPrint
        this.labelsDevolucaTotal = labels
        this.quantidadeDevolucaoTotal = quantidade
      },

      handleQuebraDevolucao (labels, quantidade, valorDevolucao) {
        this.valorQuebra = valorDevolucao
        this.labelsQuebraTotal = labels
        this.quantidadeQuebraTotal = quantidade
      },

      handleTrocaDevolucao (labels, quantidade, valorDevolucao) {
        this.valorTroca = valorDevolucao
        this.labelsTrocaTotal = labels
        this.quantidadetrocaTotal = quantidade
      },

      handleDetalheDevolucao (labels, quantidade, valorDevolucao) {
        this.valorDetalheDevolucao = valorDevolucao
        this.labelsDetalheTotal = labels
        this.quantidadeDetalheTotal = quantidade
      },

      async showDadosClientesFaturado () {
        this.loading = true

        const empresaJson = JSON.stringify(this.empresaSelect || [])

        localStorage.setItem('dataInicial', this.dataInicial)
        localStorage.setItem('dataFinal', this.dataFinal)
        localStorage.setItem('empresaId', empresaJson)

        await Clientes.showClientesFaturados(this.dataInicial, this.dataFinal, this.empresaSelect, localStorage.tokencontrato, this.vendedores, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receitaSelect, [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.clientesFaturado = resposta.data.clientesFaturado
            this.clientesTotalAtivos = resposta.data.clientesTotalAtivos
            this.semFaturamento = resposta.data.clientesTotalAtivos - resposta.data.clientesFaturado
            this.clientesAtivos = resposta.data.clientesAtivos
            this.fornecedoresAtivos = resposta.data.fornecedoresAtivos
            this.produtoresAtivos = resposta.data.produtoresAtivos
            this.funcionariosAtivos = resposta.data.funcionariosAtivos

            eventEmit.$emit('set-cobertura-participantes', this.clientesFaturado, this.clientesTotalAtivos)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },

      async showDadosNovosClientes () {
        this.loading1 = true

        await Clientes.showClientesNovos(this.dataInicial, this.dataFinal, this.empresaSelect, localStorage.tokencontrato, this.vendedores, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receitaSelect, [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.clientesNovos = resposta.data.partNovosClientes

            const idsClientes = JSON.stringify(resposta.data.codClientes)

            localStorage.setItem('clientesId', idsClientes)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error1 = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading1 = false
        })
      },

      async MontarGrafico () {
        this.loadingGrafico = true
        this.exibirLegenda = false

        if (this.myChart.data) {
          this.myChart.destroy()
          this.myChartPrint.destroy()
        }

        await Clientes.showComparativoClientes(this.dataInicial, this.dataFinal, this.empresaSelect, localStorage.tokencontrato, this.vendedores, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receitaSelect, [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.participacaoClientesNovos = (resposta.data.participacao * 100).toFixed(2).replace('.', ',') + '%'

            this.datasComparativo = resposta.data.datas
            this.faturamentoNovosClientes = resposta.data.faturamentoNovosClientes
            this.faturamentoClientes = resposta.data.faturamentoClientes

            const ctx = document.getElementById('graficoComparativoClientesNovos').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'horizontalBar',
              data: {
                labels: this.datasComparativo,
                datasets: [
                  {
                    label: 'Faturamento Novos Clientes',
                    data: this.faturamentoNovosClientes,
                    backgroundColor: '#4CAF50',
                    order: 1,
                  },
                  {
                    label: 'Faturamento Clientes',
                    data: this.faturamentoClientes,
                    backgroundColor: '#E8F5E9',
                    order: 2,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      if (tooltipItem.xLabel > 0) {
                        var type = data.datasets[tooltipItem.datasetIndex].label
                        var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                        return type + ': ' + valor
                      } else {
                        return null
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.text = resposta.data.mg

            this.errorGrafico = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
              this.myChartPrint.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.text = resposta.data.mg

            this.errorGrafico = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
              this.myChartPrint.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.errorGrafico = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingGrafico = false

          this.exibirLegenda = true
        })
      },

      enableGraficoPrint () {
        const ctxPrint = document.getElementById('graficoComparativoClientesNovosPrint').getContext('2d')

        this.myChartPrint = new Chart(ctxPrint, {
          type: 'horizontalBar',
          data: {
            labels: this.datasComparativo,
            datasets: [
              {
                label: 'Faturamento Novos Clientes',
                data: this.faturamentoNovosClientes,
                backgroundColor: '#4CAF50',
                order: 1,
              },
              {
                label: 'Faturamento Clientes',
                data: this.faturamentoClientes,
                backgroundColor: '#E8F5E9',
                order: 2,
              },
            ],
          },
          options: {
            scales: {
              y: {
                beginAtZero: true,
              },
              xAxes: [{
                stacked: true,
                gridLines: {
                  display: false,
                },
                display: false,
              }],
              yAxes: [{
                stacked: true,
                gridLines: {
                  display: false,
                },
              }],
            },
            legend: {
              display: false,
            },
            tooltips: {
              callbacks: {
                mode: 'label',
                label: (tooltipItem, data) => {
                  if (tooltipItem.xLabel > 0) {
                    var type = data.datasets[tooltipItem.datasetIndex].label
                    var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                    return type + ': ' + valor
                  } else {
                    return null
                  }
                },
              },
            },
          },
        })
      },

      async print () {
        try {
          // 210 mm × 297 mm dimensões folha A4
          // const pageWidth = 297 // Largura da folha em mm
          // const pageHeight = 210 // Altura da folha em mm
          // const pdf = new JSPDF('p', 'mm') configuraão inicial para retrato
          // const pdf = new JSPDF('landscape', 'mm', [pageWidth, pageHeight])
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 20, posY)
            posY += pdf.getTextDimensions(title).h /* + 5 */

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: fontSize, textColor: [0, 0, 0] } }))],
              body: data.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
              startY: posY,
              styles: { fontSize: fontSize },
            })

            if (title !== 'E os que mais estão caindo?') {
              await pdf.addPage()
            }

            posY = 20

            // Verificar se há espaço suficiente na página para a tabela atual
            // if (pdf.autoTableEndPosY() > 250) {
            //   await pdf.addPage()
            //   posY = 20 // Reiniciar a posição na nova página
            // } else {
            //   posY = pdf.autoTableEndPosY() + 10
            // }

            return posY
          }

          // Adicionar a imagem dos filtros usando html2canvas
          const filtrosPrint = document.getElementById('filtrosPrint')
          const canvasFiltrosPrint = await html2canvas(filtrosPrint)
          const imgWidthFiltros = 297
          const imgHeightFiltros = (canvasFiltrosPrint.height * imgWidthFiltros) / canvasFiltrosPrint.width
          let posYFiltros = 10

          // Definir a margem esquerda
          const marginLeftRem = -1
          const marginLeftPx = marginLeftRem * 16

          pdf.addImage(canvasFiltrosPrint.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthFiltros, imgHeightFiltros)
          posYFiltros += imgHeightFiltros/*  + 5 */

          // Adicionar a imagem principal usando html2canvas
          const idBloco1 = document.getElementById('idBloco1')
          const canvas = await html2canvas(idBloco1)
          const imgWidth = 290
          const imgHeight = (canvas.height * imgWidth) / canvas.width

          pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidth, imgHeight)
          posYFiltros += imgHeight/*  + 5 */

          const marginLeft = 28

          const devolucaoPeriodoId = document.getElementById('devolucaoDetalhePrintId')
          const canvasDevolucaoPeriodo = await html2canvas(devolucaoPeriodoId)
          const imgHeightDevolucaoPeriodo = (canvasDevolucaoPeriodo.height * 200) / canvasDevolucaoPeriodo.width

          pdf.addImage(canvasDevolucaoPeriodo.toDataURL('image/png'), 'PNG', 20 + marginLeft, posYFiltros, 200, imgHeightDevolucaoPeriodo)

          posYFiltros += imgHeightDevolucaoPeriodo /* + 3 */
          // pdf.addPage()
          // posYFiltros = 10

          const tiposDevolucaoId = document.getElementById('tiposDevolucaoIdPrint')
          const canvasTiposDevolucao = await html2canvas(tiposDevolucaoId)
          const imgHeightCanvasTiposDevolucao = (canvasTiposDevolucao.height * 200) / canvasTiposDevolucao.width

          pdf.addImage(canvasTiposDevolucao.toDataURL('image/png'), 'PNG', 20 + marginLeft, posYFiltros, 200, imgHeightCanvasTiposDevolucao)

          pdf.addPage()
          posYFiltros = 10

          const blocoParticipantesId = document.getElementById('blocoParticipantesNovosIdPrint')
          const canvasBlocoParticipantesId = await html2canvas(blocoParticipantesId)
          const imgHeightBlocoParticipantesId = (canvasBlocoParticipantesId.height * imgWidth) / canvasBlocoParticipantesId.width

          pdf.addImage(canvasBlocoParticipantesId.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidth, imgHeightBlocoParticipantesId)

          posYFiltros += imgHeightBlocoParticipantesId + 10

          pdf.addPage()
          posYFiltros = 10

          const titleDistruibuicaoMaps = 'Qual a distribuição geográfica dos meus clientes?'
          const tableDistruibuicaoMaps = this.dadosMapsClientes.map(item => [item.nome, item.numero, item.porcentagem])

          pdf.text(titleDistruibuicaoMaps, 20, posYFiltros)
          posYFiltros += pdf.getTextDimensions(titleDistruibuicaoMaps).h

          pdf.autoTable({
            head: [this.headersMapsClientes.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
            body: tableDistruibuicaoMaps.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
            startY: posYFiltros,
            styles: { fontSize: 10 },
          })

          // pdf.addPage()
          posYFiltros += 40

          const idBloco4 = document.getElementById('idBloco4')
          const canvasIdBloco4 = await html2canvas(idBloco4)

          const imgHeightIdBloco4 = (canvasIdBloco4.height * imgWidth) / canvasIdBloco4.width

          pdf.addImage(canvasIdBloco4.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidth, imgHeightIdBloco4)

          posYFiltros += imgHeightIdBloco4/*  + 25 */

          // Definir a fonte para as tabelas
          pdf.setFontSize(14)

          pdf.addPage()
          posYFiltros = 10

          // Adicionar a tabela "Quais meus clientes que não compraram no mês?"
          const titleNaoCompraram = 'Quais meus clientes que não compraram no mês?'
          const tableNaoFaturado = this.clientesSemFaturamento.map(item => [item.segmento_cliente, item.nome_cliente, item.dias])
          posYFiltros = await addTable(tableNaoFaturado, this.headersSemFaturamento, titleNaoCompraram, posYFiltros, 8)

          // Adicionar a tabela "Quais clientes estão prestes a inativar?"
          const titleInativo = 'Quais clientes estão prestes a inativar?'
          const tableInativo = this.clientesInativo.map(item => [item.segmento_cliente, item.nome_cliente, item.dias])
          posYFiltros = await addTable(tableInativo, this.headersSemFaturamento, titleInativo, posYFiltros, 8)

          // Adicionar a tabela "Quais são os 20 melhores clientes que performaram no ano?"
          const titleMelhoresClientes = 'Quais são os 20 melhores clientes que performaram no ano?'
          const tableMelhoresClientes = this.melhoresClientes.map(item => [item.nome_cliente, item.faturamento, item.quantidade])
          posYFiltros = await addTable(tableMelhoresClientes, this.headersMelhoresClientes, titleMelhoresClientes, posYFiltros, 8)

          // Adicionar a tabela "Quais os clientes com maior devolução?"
          const titleDevolucao = 'Quais os clientes com maior devolução?'
          const tableDevolucao = this.devolucaoClientes.map(item => [item.nome_cliente, item.valor_venda, item.valor_devolucao, item.porcentagem])
          posYFiltros = await addTable(tableDevolucao, this.headersDevolucaoClientes, titleDevolucao, posYFiltros, 8)

          // Adicionar a tabela "Quais são os 20 melhores clientes que performaram no ano?"
          const titlePerformance = 'Quais são os 20 melhores clientes que performaram no ano?'
          const tablePerformance = this.performanceClientes.map(item => [item.nome_cliente, item.quantidade, item.faturamento, item.ticket])
          posYFiltros = await addTable(tablePerformance, this.headersPerformanceClientes, titlePerformance, posYFiltros, 8)

          // Adicionar a tabela "Quais são aqueles que mais estão crescendo?"
          const title1 = 'Quais são aqueles que mais estão crescendo?'
          const tableData1 = this.clientesMaiorCrescimento.map(item => [item.nome_cliente, item.faturamento_anterior, item.faturamento, item.variacao])
          posYFiltros = await addTable(tableData1, this.headersClientesMelhoresPiores, title1, posYFiltros, 8)

          // Adicionar a tabela "E os que mais estão caindo?"
          const title2 = 'E os que mais estão caindo?'
          const tableData2 = this.clientesPioresCrescimento.map(item => [item.nome_cliente, item.faturamento_anterior, item.faturamento, item.variacao])
          posYFiltros = await addTable(tableData2, this.headersClientesMelhoresPiores, title2, posYFiltros, 8)

          // Salvar o PDF
          pdf.save('relatorio_consultor_vendas.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.loadingPrint = false
          this.loadingBtnPrint = true
          this.enableTituloWeb = true
          this.enableTituloPrint = false
          this.enableTextoWeb = true
          this.enableTextoPrint = false

          setTimeout(() => {
            this.updateGrafico()

            eventEmit.$emit('disable-print', true)

            eventEmit.$emit('enable-map', true, this.dadosMapsClientes, this.locations, this.zoom, this.center)

            eventEmit.$emit('enable-cobertura-participantes', this.porcentagem, this.restante)

            eventEmit.$emit('enable-detalhe-devolucao', this.valorDevolucaoPrint, this.labelsDevolucaTotal, this.quantidadeDevolucaoTotal)

            eventEmit.$emit('enable-quebra', this.valorQuebra, this.labelsQuebraTotal, this.quantidadeQuebraTotal)

            eventEmit.$emit('enable-troca', this.valorTroca, this.labelsTrocaTotal, this.quantidadetrocaTotal)

            eventEmit.$emit('enable-dev-total', this.valorDetalheDevolucao, this.labelsDetalheTotal, this.quantidadeDetalheTotal)

            eventEmit.$emit('enable-filtros-print', this.mes, this.ano, this.vendedores)
          }, 1500)
        }
      },

      imprimir () {
        eventEmit.$emit('enable-print', true)

        this.loadingPrint = true
        this.loadingBtnPrint = false
        this.enableTituloWeb = false
        this.enableTituloPrint = true
        this.enableTextoWeb = false
        this.enableTextoPrint = true

        eventEmit.$emit('exibir-legenda-maps-print', true)

        eventEmit.$emit('disable-map', false)

        setTimeout(() => {
          this.enableGraficoPrint()

          this.enableGraficoCoberturaParticipantes()

          this.enableDevolucaototal()

          this.enableDevolucaoQuebra()

          this.enableDevolucaoTroca()

          this.enableDevolucaoDetalhe()
        }, 1000)

        setTimeout(() => {
          this.print()
        }, 3000)
      },

      enableGraficoCoberturaParticipantes () {
        if (this.myChartCoberturaParticipantes.data) {
          this.myChartCoberturaParticipantes.destroy()
        }

        const ctxCobertura = document.getElementById('graficoPorcentagemClientesPrint').getContext('2d')

        this.myChartCoberturaParticipantes = new Chart(ctxCobertura, {
          type: 'doughnut',
          data: {
            labels: ['Porcentagem'],
            datasets: [
              {
                label: 'Porcentagem',
                data: [this.porcentagem, this.restante],
                backgroundColor: [
                  '#ed934f',
                  '#cadaed',
                ],
              },
            ],
          },
          options: {
            legend: {
              display: false,
            },
            responsive: true,
            cutoutPercentage: 70,
            tooltips: {
              enabled: false,
            },
          },
        })
      },

      enableDevolucaoQuebra () {
        const ctxQuebra = document.getElementById('graficoDevolucaoQuebraPrint').getContext('2d')

        this.mychartDevolucaoTotalQuebra = new Chart(ctxQuebra, {
          type: 'bar',
          data: {
            labels: this.labelsQuebra,
            datasets: [
              {
                label: 'Devolução',
                data: this.quantidadeQuebraTotal,
                backgroundColor: '#4780b8',
                order: 1,
              },
            ],
          },
          options: {
            scales: {
              yAxes: [
                {
                  gridLines: {
                    display: true,
                  },
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
              xAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  display: false,
                  barPercentage: 0.2,
                },
              ],
            },
            legend: {
              display: false,
            },
          },
        })
      },

      enableDevolucaoTroca () {
        const ctxTroca = document.getElementById('graficoTotalTrocaPrint').getContext('2d')

        this.mychartDevolucaoTotalTroca = new Chart(ctxTroca, {
          type: 'bar',
          data: {
            labels: this.labelsTrocaTotal,
            datasets: [
              {
                label: 'Devolução',
                data: this.quantidadetrocaTotal,
                backgroundColor: '#4780b8',
                order: 1,
              },
            ],
          },
          options: {
            scales: {
              yAxes: [
                {
                  gridLines: {
                    display: true,
                  },
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
              xAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  display: false,
                  barPercentage: 0.2,
                },
              ],
            },
            legend: {
              display: false,
            },
          },
        })
      },

      enableDevolucaoDetalhe () {
        const ctxDetalhe = document.getElementById('graficoTotalDevolucaoPrint').getContext('2d')

        this.mychartDevolucaoTotalPrint = new Chart(ctxDetalhe, {
          type: 'bar',
          data: {
            labels: this.labelsDetalheTotal,
            datasets: [
              {
                label: 'Devolução',
                data: this.quantidadeDetalheTotal,
                backgroundColor: '#4780b8',
                order: 1,
              },
            ],
          },
          options: {
            scales: {
              yAxes: [
                {
                  gridLines: {
                    display: true,
                  },
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
              xAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  display: false,
                  barPercentage: 0.2,
                },
              ],
            },
            legend: {
              display: false,
            },
          },
        })
      },

      enableDevolucaototal () {
        const ctxGraficoDetalheDevolucao = document.getElementById('graficoDevolucaoDetalheTotalPrint').getContext('2d')

        this.myChartDevolucaoTotalPrint = new Chart(ctxGraficoDetalheDevolucao, {
          type: 'horizontalBar',
          data: {
            labels: this.labelsDevolucaTotal,
            datasets: [
              {
                label: 'Devolução',
                data: this.quantidadeDevolucaoTotal,
                backgroundColor: '#4780b8',
                order: 1,
              },
            ],
          },
          options: {
            layout: {
              padding: {
                left: 10, // Ajuste o valor conforme necessário para dar espaço aos labels
              },
            },
            scales: {
              yAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  ticks: {
                    fontSize: 12,
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    min: 0,
                  },
                },
              ],
            },
            legend: {
              display: false,
            },
          },
        })
      },

      enableTexto (value) {
        var i = 0

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '159') {
            this.textoParticipantes = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '160') {
            this.textoDistribuicaoParticipantes = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '161') {
            this.textoParticipantesNovos = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '162') {
            this.textoDistribuicaoMeses = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '165') {
            this.textoParticpantesSegmento = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '166') {
            this.textoParticpantesMelhores = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '167') {
            this.textoParticpantesDevolucao = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '168') {
            this.textoParticpantesPerfomance = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '169') {
            this.textoParticpantesCrescendo = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '170') {
            this.textoParticpantesCaindo = this.orientacao[i].descricao
          }
        }
      },

      updateGrafico () {
        setTimeout(() => {
          if (this.myChart.data) {
            this.myChart.destroy()
          }

          const ctx = document.getElementById('graficoComparativoClientesNovos').getContext('2d')

          this.myChart = new Chart(ctx, {
            type: 'horizontalBar',
            data: {
              labels: this.datasComparativo,
              datasets: [
                {
                  label: 'Faturamento Novos Clientes',
                  data: this.faturamentoNovosClientes,
                  backgroundColor: '#4CAF50',
                  order: 1,
                },
                {
                  label: 'Faturamento Clientes',
                  data: this.faturamentoClientes,
                  backgroundColor: '#E8F5E9',
                  order: 2,
                },
              ],
            },
            options: {
              scales: {
                y: {
                  beginAtZero: true,
                },
                xAxes: [{
                  stacked: true,
                  gridLines: {
                    display: false,
                  },
                  display: false,
                }],
                yAxes: [{
                  stacked: true,
                  gridLines: {
                    display: false,
                  },
                }],
              },
              legend: {
                display: false,
              },
              tooltips: {
                callbacks: {
                  mode: 'label',
                  label: (tooltipItem, data) => {
                    if (tooltipItem.xLabel > 0) {
                      var type = data.datasets[tooltipItem.datasetIndex].label
                      var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                      return type + ': ' + valor
                    } else {
                      return null
                    }
                  },
                },
              },
            },
          })
        }, 1500)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    #iconInformationNovosClientesParcipantes {
      margin: auto;
    }

    #iconInformationNovosClientes {
      margin: -7rem 0 0 0;
    }

    #linkNovosClientes {
      margin: -7.3rem 0 0 25rem;
    }

    #textoClientesNovos {
      font-size: 22px;
      font-weight: bold;
      margin: -2rem 0 0 -11rem;
    }

    #iconCombinado {
      margin: -8rem 0 0 -20rem;
    }

    #textoParticipacao {
      margin: -11.5rem 0 0 8rem;
      font-size: 14px;
      font-weight: bold;
    }

    #percentualParticipacao {
      margin: 0 0 0 10rem;
      color: #4CAF50;
      font-size: 22px;
      font-weight: bold;
    }

    #filtrosOpcoesClientesRFV {
      color: black;
      margin: 0 0 0 -25rem;
    }

    #filtrosOpcoesClientesExtrato {
      color: black;
      margin: -6.6rem 0 0 -3rem;
    }

    #filtrosOpcoesClientesABC {
      color: black;
      margin: -8.2rem 0 0 21rem;
    }

    #idClientesParticantes {
      margin: -3rem 0 0 0;
    }

    #graficoComparativoClientesNovos {
      margin: -12rem 0 0 0;
    }

    #legendaDistribuicaoCliente {
      font-size: 10px;
      margin: 1.5rem 0 1rem 10rem
    }

    #fornecedoresAtivosPrint {
      margin: -5.6rem 0 0 16.5rem
    }

    #funcionariosAtivosPrint {
      margin: -5.6rem 0 0 16.3rem !important
    }
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #iconInformationNovosClientesParcipantes {
      margin: auto;
    }

    #iconInformationNovosClientes {
      margin: -7rem 0 0 0;
    }

    #linkNovosClientes {
      margin: -7.3rem 0 0 25rem;
    }

    #textoClientesNovos {
      font-size: 22px;
      font-weight: bold;
      margin: 0 0 0 -11rem;
    }

    #iconCombinado {
      margin: -8rem 0 0 -20rem;
    }

    #textoParticipacao {
      margin: -11rem 0 0 12rem;
      font-size: 14px;
      font-weight: bold;
    }

    #percentualParticipacao {
      margin: 0 0 0 14rem;
      color: #4CAF50;
      font-size: 22px;
      font-weight: bold;
    }

    #filtrosOpcoesClientesRFV {
      color: black;
      margin: 2rem 0 0 -6rem;
    }

    #filtrosOpcoesClientesExtrato {
      color: black;
      margin: 2rem 0 0 1rem;
    }

    #filtrosOpcoesClientesABC {
      color: black;
      margin: 2rem 0 0 7rem;
    }

    #idClientesParticantes {
      margin: -1rem 0 0 0;
    }

    #graficoComparativoClientesNovos {
      margin: -12rem 0 0 0;
    }

    #legendaDistribuicaoCliente {
      font-size: 10px;
      margin: 1rem 0 0 0;
    }

    #fornecedoresAtivosPrint {
      margin: -5.6rem 0 0 16.5rem
    }

    #funcionariosAtivosPrint {
      margin: -5.6rem 0 0 16.3rem !important
    }
  }

  @media screen
  and (min-width : 1380px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #fornecedoresAtivosPrint {
      margin: -5.6rem 0 0 16.5rem
    }

    #funcionariosAtivosPrint {
      margin: -5.6rem 0 0 16.3rem !important
    }
  }
</style>

<style lang="sass">
  #filtrosPrint
    margin: 1rem 0 1rem 1rem
    font-size: 18px

  #textoTitulo
    margin: 2.7rem 0 0 0rem
    font-size: 17px

  #bloco2
    margin: 0 0 0 1rem

  #btnPrint
    margin: 1rem 0 1rem 0.5rem

  .hidden
    display: none

  #opcoesClientes
    margin: -2rem 0 0 0

  #clientesParticantes
    font-size: 14px
    font-weight: bold

  #novosClientes
    margin-left: -2rem

  #iconInformationNovosClientes
    margin-left: -2rem

  #distribuicaoClientes
    font-size: 14px
    font-weight: bold

  #partcipacaoNovosClientes
    font-size: 14px
    font-weight: bold

  #clientePositivados
    font-size: 22px
    font-weight: bold

  #textoClientesNovos
    font-size: 22px
    font-weight: bold

  #textoClientesNovosPrint
    font-size: 24px
    font-weight: bold
    margin: 2rem 0 0 -16rem

  #iconCombinadoPrint
    margin: -9rem 0 0 32rem

  #linkNovosClientes
    margin: 0.5rem 0 0 0

  #currencyCliente
    margin: -5.5rem 0 0 -2.5rem
    font-size: 26px
    font-weight: bold

  #handCliente
    margin: -2rem 0 0 0
    font-size: 42px
    font-weight: bold

  #handClientePrint
    margin: 5rem 0 0 -24rem
    font-size: 42px
    font-weight: bold

  #currencyClientePrint
    margin: 0.5rem 0 0 -2.5rem
    font-size: 26px
    font-weight: bold

  #textoParticipacaoPrint
    margin: -7.5rem 0 0 28.3rem
    font-size: 14px
    font-weight: bold

  #percentualParticipacaoPrint
    margin: 0.5rem 0 0 30rem
    color: #4CAF50
    font-size: 22px
    font-weight: bold

  #textoParticipacao
    margin: -3rem 0 0 -4.3rem
    font-size: 14px
    font-weight: bold

  #percentualParticipacao
    margin: 0 0 0 -4.3rem
    color: #4CAF50
    font-size: 22px
    font-weight: bold

  #linkDetalheMelhoresClientes
    color: black

  #filtrosOpcoesClientesRFV
    color: black

  #filtrosOpcoesClientesExtrato
    color: black

  #filtrosOpcoesClientesABC
    color: black

  #iconCliente
    font-size: 48px

  .container
    max-width: 100%

  #melhoresClientes
    margin: -0.8rem 0 0 0rem

  #iconInformationMelhoresClientes
    margin: -1.5rem 0 0 0

  #legendaDistribuicaoCliente
    margin: 1.5rem 0 0 0
    font-size: 11px

  #graficoComparativoClientesNovos
    margin: -3rem 0 0 0

  #graficoComparativoClientesNovosPrint
    margin: -3rem 0 0 8rem
    width: 500px !important
    height: 360px !important

  #legendaDistribuicaoClientePrint
    margin: 1rem 0 0 0

  #testePrint
    display: none

  .tituloWeb
    font-size: 18px

  #coberturaParticipantesPrint
    margin: 2rem 0 0 -2rem !important

  #graficoPorcentagemClientesPrint
    width: 363px !important
    height: 170px !important
    margin: 0 0 0 9rem !important

  #dadosPrint
    margin: 3rem 0 0 -9rem
    font-size: 18px !important

  #textoMapsId
    margin: 8rem 0 0 0

  #tabelaMapsPrint
    margin: 0 0 0 10rem

  #porcentagemClienteFaturadoPrint
    font-size: 24px
    margin: -7rem 0 0 0

  #participacaoNovosId
    // margin: 2rem 0 3rem 0

  #positivadosPrint
    margin: 7rem 0 0 7rem
    font-size: 22px

  #ativosPrint
    margin: -4.1rem 0 0 26rem
    font-size: 22px

  #clientesAtivosPrint
    margin: 4rem 0 0 7rem
    font-size: 22px

  #fornecedoresAtivosPrint
    margin: -5.6rem 0 0 10.5rem

  #produtoresAtivosPrint
    margin: 0rem 0 0 0rem

  #funcionariosAtivosPrint
    margin: -5.6rem 0 0 10.3rem

  #textoPrint
    font-size: 18px

  #devolucaoTotalPrint
    margin: 0 0 0 1rem

  #valorDevolucaoTotalPrint
    margin: 0 0 0 -1.65rem

  #totalQuebraPrint
    margin: 0 0 0 -1.7rem

  #totalTrocaPrint
    margin: 0 0 0 -1.7rem

  #totalDevolucaoPrint
    margin: 0 0 0 -1.75rem

  #textoDevTotalPrint
    margin: 0 0 0 -2rem
    font-size: 18px

  #graficoDevolucaoDetalheTotalPrint
    // width: 818px !important
    // height: 500px !important
    // margin: 0 0 0 10rem !important

  #graficoDevolucaoQuebraPrint
    // width: 400px !important
    // height: 420px !important
    width: 344px !important
    height: 235px !important

  #graficoTotalTrocaPrint
    // width: 400px !important
    // height: 420px !important
    width: 344px !important
    height: 235px !important

  #graficoTotalDevolucaoPrint
    // width: 400px !important
    // height: 420px !important
    width: 344px !important
    height: 235px !important

  #valorDevTotalId
    margin: 0 0 0 -1.65rem

  #textoQuebraPrint
    font-size: 18px
    width: 29.6rem

  #textoTrocaPrint
    font-size: 18px
    width: 29.6rem

  #textoDevolucaoPrint
    font-size: 18px
    width: 28.6rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemClientes
    margin: -2rem 0 0 -1rem

  #listItemClientesMaps
    margin: -2rem 0 0 -1rem

  #listItemClientesNovos
    margin: -2rem 0 0 -1rem

  #listItemDistruibuicaoClientes
    margin: -2rem 0 0 -1rem

</style>
